export default {
    clean_up_area: {
        name: "Clean Up Area",
        url: "nwcg_repair/clean_up_area",
    },
    culvert: {
        name: "Culvert",
        url: "nwcg_repair/culvert",
    },
    dozer_push: {
        name: "Dozer Push",
        url: "nwcg_repair/dozer_push",
    },
    fence_damaged: {
        name: "Fence Damaged",
        url: "nwcg_repair/fence_damaged",
    },
    hazard_tree: {
        name: "Hazard Tree",
        url: "nwcg_repair/hazard_tree",
    },
    landing_or_log_deck: {
        name: "Landing Or Log Deck",
        url: "nwcg_repair/landing_or_log_deck",
    },
    repair_point: {
        name: "Repair Point",
        url: "nwcg_repair/repair_point",
    },
    resource_location: {
        name: "Resource Location",
        url: "nwcg_repair/resource_location",
    },
    retardant_in_avoidance_area: {
        name: "Retardant In Avoidance Area",
        url: "nwcg_repair/retardant_in_avoidance_area",
    },
    road_repair: {
        name: "Road Repair",
        url: "nwcg_repair/road_repair",
    },
    stream_crossing: {
        name: "Stream Crossing",
        url: "nwcg_repair/stream_crossing",
    },
    structure_wrap: {
        name: "Structure Wrap",
        url: "nwcg_repair/structure_wrap",
    },
    water_development_for_draft_site: {
        name: "Water Development For Draft Site",
        url: "nwcg_repair/water_development_for_draft_site",
    },
}
